<template>
		<v-menu
			offset-y
			bottom
			left
			:close-on-content-click="false"
			:value="show"
			open-on-click
			v-model="show"
		>
			<template v-slot:activator="{ on, attrs }">
				<v-icon v-bind="attrs" v-on="on">{{ icon }}</v-icon>
			</template>
			<Picker :data="emojiIndex" set="twitter" :i18n="strings" :showPreview="false" :title="null" @select="showEmoji" width="400px" />
		</v-menu>
</template>

<script>
import data from "emoji-mart-vue-fast/data/all.json";
import "emoji-mart-vue-fast/css/emoji-mart.css";
import { Picker, EmojiIndex } from "emoji-mart-vue-fast";
let emojiIndex = new EmojiIndex(data);
export default {
	name: "ContentEditableInputEmojiPicker",
	components: {
		Picker
	},
	props: {
		icon: {
			type: String
		}
	},
	data() {
		return {
			emojiIndex: emojiIndex,
			emojisOutput: "",
			show: false,
		};
	},
	computed: {
		strings() {
			return {
				search: this.$vuetify.lang.t('$vuetify.emojiMart.search'),
				clear: this.$vuetify.lang.t('$vuetify.emojiMart.clear'),
				notfound: this.$vuetify.lang.t('$vuetify.emojiMart.notfound'),
				skintext: this.$vuetify.lang.t('$vuetify.emojiMart.skintext'),
				categories: {
					search: this.$vuetify.lang.t('$vuetify.emojiMart.categories.search'),
					recent: this.$vuetify.lang.t('$vuetify.emojiMart.categories.recent'),
					smileys: this.$vuetify.lang.t('$vuetify.emojiMart.categories.smileys'),
					people: this.$vuetify.lang.t('$vuetify.emojiMart.categories.people'),
					nature: this.$vuetify.lang.t('$vuetify.emojiMart.categories.nature'),
					foods: this.$vuetify.lang.t('$vuetify.emojiMart.categories.foods'),
					activity: this.$vuetify.lang.t('$vuetify.emojiMart.categories.activity'),
					places: this.$vuetify.lang.t('$vuetify.emojiMart.categories.places'),
					objects: this.$vuetify.lang.t('$vuetify.emojiMart.categories.objects'),
					symbols: this.$vuetify.lang.t('$vuetify.emojiMart.categories.symbols'),
					flags: this.$vuetify.lang.t('$vuetify.emojiMart.categories.flags'),
					custom: this.$vuetify.lang.t('$vuetify.emojiMart.categories.custom'),
				},
				categorieslabel: this.$vuetify.lang.t('$vuetify.emojiMart.categorieslabel'),
				skintones: {
					1: this.$vuetify.lang.t('$vuetify.emojiMart.skintones.1'),
					2: this.$vuetify.lang.t('$vuetify.emojiMart.skintones.2'),
					3: this.$vuetify.lang.t('$vuetify.emojiMart.skintones.3'),
					4: this.$vuetify.lang.t('$vuetify.emojiMart.skintones.4'),
					5: this.$vuetify.lang.t('$vuetify.emojiMart.skintones.5'),
					6: this.$vuetify.lang.t('$vuetify.emojiMart.skintones.6'),
				},
			}
		}
	},
	methods: {
		showEmoji(emoji) {
			this.show = false
			this.$emit('input', emoji.native)
		}
	}
}
</script>

<style lang="scss">
.content-editable-input-emoji-picker {
	position: relative;
	//> section {
	//	position: absolute;
	//	right: 0;
	//	z-index: 2;
	//}
}
</style>
